module.exports = __webpack_public_path__ + "static/media/strongher14.6e6d2ff0.jpg";